<template>
  <section class="sponsors">
    <div class="sponsors__content">
      <h1 class="sponsors__title">
          Sponsors
      </h1>
      <div class="sponsors__logos">
        <a href="https://www.casperlabs.io/" target="_blank">
          <div class="sponsors__item">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/casper.png" alt="Casper Labs" class="full-logo">
            </div>
            <h2 class="sponsors__name">Casper Labs</h2>
            <div class="sponsors__badge gold">
              <p> Gold </p>
            </div>
          </div>
        </a>
        <a href="https://theseg.com/" target="_blank">
          <div class="sponsors__item">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/seg.png" alt="SEG" class="logo">
            </div>
            <h2 class="sponsors__name">SEG</h2>
            <div class="sponsors__badge gold">
              <p> Gold </p>
            </div>
          </div>
        </a>
        <a href="https://www.mzgroup.com/" target="_blank">
          <div class="sponsors__item">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/mz.png" alt="MZ Group" class="logo">
            </div>
            <h2 class="sponsors__name">MZ Group</h2>
            <div class="sponsors__badge gold">
              <p> Gold </p>
            </div>
          </div>
        </a>
        <a href="https://www.m2compliance.com/" target="_blank">
          <div class="sponsors__item">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/m2.png" alt="M2 Compliance" class="logo m2">
            </div>
            <h2 class="sponsors__name">M2 Compliance</h2>
            <div class="sponsors__badge gold">
              <p> Gold </p>
            </div>
          </div>
        </a>
        <a href="https://www.josephgunnar.com/" target="_blank">
          <div class="sponsors__item">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/joseph.png" alt="Joseph Gunnar" class="full-logo">
            </div>
            <h2 class="sponsors__name">Joseph Gunnar</h2>
            <div class="sponsors__badge silver">
              <p> Silver </p>
            </div>
          </div>
        </a>

        <a href="https://www.allianceg.com/" target="_blank">
          <div class="sponsors__item">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/AGP.png" alt="Alliance Global Partners" class="full-logo">
            </div>
            <h2 class="sponsors__name">A.G.P.</h2>
            <div class="sponsors__badge silver">
              <p> Silver </p>
            </div>
          </div>
        </a>
        <a href="https://www.vstocktransfer.com/" target="_blank">
          <div class="sponsors__item single">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/vstock.png" alt="V Stock Transfer" class="logo">
            </div>
            <h2 class="sponsors__name">V Stock Transfer</h2>
          </div>
        </a>
        <a href="https://cronelawgroup.com/" target="_blank">
          <div class="sponsors__item single">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/clg.png" alt="CLG" class="logo">
            </div>
            <h2 class="sponsors__name smaller">The Crone Law Group</h2>
          </div>
        </a>
        <a href="https://www.edgaragents.com/" target="_blank">
          <div class="sponsors__item single">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/edgar.png" alt="Edgar Agents" class="logo">
            </div>
            <h2 class="sponsors__name">EdgarAgents</h2>
          </div>
        </a>
        <a href="https://cmfllp.com/" target="_blank">
          <div class="sponsors__item single">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/cmf.png" alt="CMF LLP" class="logo">
            </div>
            <h2 class="sponsors__name smaller">Carmel, Milazzo & Feil</h2>
          </div>
        </a>
        <a href="https://www.moneychannelnyc.com/" target="_blank">
          <div class="sponsors__item single">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/moneychannel.png" alt="The Money Channel" class="full-logo">
            </div>
            <h2 class="sponsors__name">The Money Channel</h2>
          </div>
        </a>
        <a href="https://www.datatracks.com/" target="_blank">
          <div class="sponsors__item single">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/dtracks.png" alt="DataTracks" class="full-logo">
            </div>
            <h2 class="sponsors__name">DataTracks</h2>
          </div>
        </a>
        <a href="https://assurtrak.com/" target="_blank">
          <div class="sponsors__item single">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/assurtrak.png" alt="AssurTrak" class="full-logo">
            </div>
            <h2 class="sponsors__name">AssurTrak</h2>
          </div>
        </a>
        <a href="https://factoreseconomicos.com/" target="_blank">
          <div class="sponsors__item single facteco">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/factoreseco.png" alt="Factores Económicos" class="full-logo">
            </div>
            <h2 class="sponsors__name smaller">Factores Económicos</h2>
          </div>
        </a>
        <a href="https://www.investpr.org/" target="_blank">
          <div class="sponsors__item single invpr">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/investpr.png" alt="Invest Puerto Rico" class="full-logo">
            </div>
            <h2 class="sponsors__name">Invest Puerto Rico</h2>
          </div>
        </a>
        <a href="https://thecolectivogroup.com/" target="_blank">
          <div class="sponsors__item single invpr">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/colective.png" alt="Invest Puerto Rico" class="full-logo">
            </div>
            <h2 class="sponsors__name">Colectivo Group</h2>
          </div>
        </a>
        <a href="https://ir.skyplug.com/" target="_blank">
          <div class="sponsors__item single">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/skyx.png" alt="SKYX Platforms" class="full-logo">
            </div>
            <h2 class="sponsors__name">SKYX Platforms</h2>
          </div>
        </a>
        <a href="https://ideanomics.com/our-group/" target="_blank">
          <div class="sponsors__item single">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/presenters/idex.png" alt="Ideanomics" class="full-logo">
            </div>
            <h2 class="sponsors__name">Ideanomics</h2>
          </div>
        </a>
        <a href="https://www.uncommonentrepreneurs.com/" target="_blank">
          <div class="sponsors__item single">
            <div class="sponsors__logo-container nobg uncommon">
              <img src="../assets/sponsors/uncommon.png" alt="Uncommon EntrePReneurs" class="full-logo">
            </div>
            <h2 class="sponsors__name smaller">Uncommon EntrePReneurs</h2>
          </div>
        </a>
        <a href="https://rumcapital.pr.gov/" target="_blank">
          <div class="sponsors__item single">
            <div class="sponsors__logo-container nobg">
              <img src="../assets/sponsors/rums.png" alt="RUMS Puerto Rico" class="full-logo">
            </div>
            <h2 class="sponsors__name ">RUMS</h2>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/sponsors.scss';
</style>

<script>

export default {
  name: 'sponsors',
  data() {
    return {
    };
  },
};
</script>